module.exports = __webpack_public_path__ + "assets/img/check.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check.png
// module id = 1922
// module chunks = 0